import * as Comp from './link-label.styles'

import type { TLinkProps } from '../../types'

export function LinkLabel({
  children,
  size = 'ml',
  disabled,
}: Partial<TLinkProps>) {
  return (
    <Comp.Label size={size} hasDisabled={disabled}>
      {children}
    </Comp.Label>
  )
}
